import { ticketConstants } from '../Constants';
import { adminUsersServices } from '../Services';

export const  ticketUsersActions = {
    searchTicket,
};

function searchTicket(data:any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: ticketConstants.SEARCH_TICKET_REQUEST,
            data: null
        }));
        adminUsersServices.searchTicket(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: ticketConstants.SEARCH_TICKET_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: ticketConstants.SEARCH_TICKET_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: ticketConstants.SEARCH_TICKET_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}


function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}